// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 1200px) {
  .SelectReference_wrap__9GOK2 {
    position: absolute;
    width: 256px;
    z-index: 3;
    background-color: var(--white);
    border: 1px solid var(--gray-100);
    border-radius: 4px;
    padding: 8px;
  }
}
.SelectReference_wrap__9GOK2 .employees__grid {
  display: block;
}
.SelectReference_wrap__9GOK2 .searchBlock {
  margin-bottom: 16px;
  margin-top: 0;
}
@media (min-width: 1200px) {
  .SelectReference_wrap__9GOK2 .searchBlock {
    margin-bottom: 4px;
  }
}
.SelectReference_wrap__9GOK2 .searchBlock input {
  height: 28px;
  border-radius: 4px;
  padding: 6px;
  background: #F0F1F5;
}
.SelectReference_wrap-is-objects__TFn8v {
  max-width: 630px;
  width: 100%;
}

.SelectReference_footer__XVmdW {
  display: flex;
  align-items: center;
  grid-column-gap: 8px;
  padding-top: 8px;
}
@media (min-width: 1200px) {
  .SelectReference_footer__XVmdW {
    grid-column-gap: 4px;
  }
}

.SelectReference_btnSubmit__ViguV {
  flex: 1 1;
}

.SelectReference_btnReset__-rmuy {
  width: auto;
}

.SelectReference_grid__k-syf {
  display: block;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 12px;
  margin-bottom: 12px;
}
@media (min-width: 768px) {
  .SelectReference_grid__k-syf {
    display: grid;
  }
}
.SelectReference_grid--is-skeleton__CPA2a {
  margin-bottom: 0;
}

.SelectReference_skeleton__4VK-D {
  width: 100%;
  height: 164px;
  border-radius: 12px;
  margin-bottom: 12px;
}
.SelectReference_skeleton__4VK-D:last-child {
  margin-bottom: 0;
}
@media (min-width: 768px) {
  .SelectReference_skeleton__4VK-D {
    margin-bottom: 0;
  }
}
.SelectReference_skeleton--sm__IIQgU {
  height: 34px;
  margin-bottom: 2px;
}
.SelectReference_skeleton--xl__HfjIC {
  height: 56px;
  margin-bottom: 2px;
}

.SelectReference_label__XiT82 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding-right: 6px;
}
@media (min-width: 1200px) {
  .SelectReference_label__XiT82 {
    padding-right: 0;
  }
}
.SelectReference_label--hierarhical__Rf\\+Q- {
  padding-right: 6px;
  height: 48px;
  align-items: stretch;
}
.SelectReference_label--hierarhical__Rf\\+Q- .SelectReference_inputWrap__NV6Fi {
  order: -1;
  position: initial;
  width: 16px;
  height: 100%;
  transform: initial;
  margin-right: 8px;
}
.SelectReference_label--hierarhical__Rf\\+Q- .SelectReference_inputWrap__NV6Fi svg {
  display: flex;
}
.SelectReference_label--hierarhical__Rf\\+Q- .SelectReference_inputWrap__NV6Fi .SelectReference_itemIco__sfU0\\+ {
  display: flex;
  width: 14px;
  height: 14px;
  min-width: 14px;
}
.SelectReference_label--hierarhical__Rf\\+Q- .SelectReference_inputWrap__NV6Fi .SelectReference_itemIco__sfU0\\+::before {
  width: 6px;
  height: 6px;
}
@media (hover: hover) {
  .SelectReference_label__XiT82:hover svg {
    color: var(--white);
  }
}
.SelectReference_label__XiT82 .SelectReference_item__8lG7J {
  flex: 1 1;
  padding-right: 24px;
}

.SelectReference_arrowRight__I1WrV {
  width: 24px;
  height: 48px;
  padding-left: 8px;
  height: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0 4px 4px 0;
  flex-shrink: 0;
}
.SelectReference_arrowRight__I1WrV svg {
  fill: var(--text-color);
}
@media (hover: hover) {
  .SelectReference_arrowRight__I1WrV:hover {
    background-color: var(--accent-color);
    filter: opacity(0.5);
  }
  .SelectReference_arrowRight__I1WrV:hover svg {
    fill: #fff;
  }
}

.SelectReference_arrowRightPlug__H4zxw {
  width: 24px;
  height: 40px;
  flex-shrink: 0;
}

.SelectReference_inputWrap__NV6Fi {
  flex-shrink: 0;
  color: var(--accent-color);
  width: 22px;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 1200px) {
  .SelectReference_inputWrap__NV6Fi {
    position: absolute;
    right: 0;
    width: auto;
    height: auto;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.SelectReference_inputWrap__NV6Fi svg {
  display: none;
}
@media (min-width: 1200px) {
  .SelectReference_inputWrap__NV6Fi svg {
    display: flex;
  }
}
.SelectReference_inputWrap__NV6Fi input:checked ~ .SelectReference_itemIco__sfU0\\+ {
  border-color: transparent;
  background-color: var(--accent-color);
}

.SelectReference_itemIco__sfU0\\+ {
  display: flex;
  border-radius: 50%;
  width: 14px;
  min-width: 14px;
  height: 14px;
  border: 1px solid #D9D9D9;
  position: relative;
  transition: 0.2s;
}
@media (min-width: 640px) {
  .SelectReference_itemIco__sfU0\\+ {
    width: 20px;
    min-width: 20px;
    height: 20px;
  }
}
@media (min-width: 1200px) {
  .SelectReference_itemIco__sfU0\\+ {
    display: none;
  }
}
.SelectReference_itemIco__sfU0\\+::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 6px;
  height: 6px;
  background: #fff;
  border-radius: 50%;
}
@media (min-width: 640px) {
  .SelectReference_itemIco__sfU0\\+::before {
    width: 12px;
    height: 12px;
  }
}
@media (min-width: 1200px) {
  .SelectReference_itemIco__sfU0\\+::before {
    width: 6px;
    height: 6px;
  }
}

.SelectReference_item--hierarhical__GLI7\\+ {
  align-items: center;
}
@media (hover: hover) {
  .SelectReference_item--hierarhical__GLI7\\+:hover {
    filter: opacity(0.5);
  }
}

.SelectReference_backButton__K6dIh {
  background: #EEE;
  color: var(--text-color);
  padding: 6px 12px 6px 4px;
  display: flex;
  gap: 8px;
  align-items: center;
  border-radius: 47px;
  font-size: var(--fz-md);
  line-height: var(--lh-lg);
  font-weight: 400;
  margin-top: 4px;
  margin-bottom: 4px;
  word-break: break-all;
}
.SelectReference_backButton__K6dIh .SelectReference_svgWp__5Itop {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/components/SelectReference/SelectReference.module.scss"],"names":[],"mappings":"AACE;EADF;IAEI,kBAAA;IACA,YAAA;IACA,UAAA;IACA,8BAAA;IACA,iCAAA;IACA,kBAAA;IACA,YAAA;EACF;AACF;AAGM;EACE,cAAA;AADR;AAKI;EACE,mBAAA;EACA,aAAA;AAHN;AAKM;EAJF;IAKI,kBAAA;EAFN;AACF;AAIM;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AAFR;AAcE;EACE,gBAAA;EACA,WAAA;AAZJ;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;AAbF;AAeE;EANF;IAOI,oBAAA;EAZF;AACF;;AAeA;EACE,SAAA;AAZF;;AAeA;EACE,WAAA;AAZF;;AAeA;EACE,cAAA;EACA,qCAAA;EACA,cAAA;EACA,mBAAA;AAZF;AAcE;EANF;IAOI,aAAA;EAXF;AACF;AAaE;EACE,gBAAA;AAXJ;;AAeA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EAEA,mBAAA;AAbF;AAeE;EACE,gBAAA;AAbJ;AAgBE;EAXF;IAYI,gBAAA;EAbF;AACF;AAeE;EACE,YAAA;EACA,kBAAA;AAbJ;AAgBE;EACE,YAAA;EACA,kBAAA;AAdJ;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;AAfF;AAiBE;EAPF;IAQI,gBAAA;EAdF;AACF;AAgBE;EACE,kBAAA;EACA,YAAA;EACA,oBAAA;AAdJ;AAkBI;EACE,SAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAhBN;AAkBM;EACE,aAAA;AAhBR;AAmBM;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAjBR;AAmBQ;EACE,UAAA;EACA,WAAA;AAjBV;AAuBE;EAEI;IACE,mBAAA;EAtBN;AACF;AA0BE;EACE,SAAA;EACA,mBAAA;AAxBJ;;AA4BA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,cAAA;AAzBF;AA2BE;EACE,uBAAA;AAzBJ;AA4BE;EACE;IACE,qCAAA;IACA,oBAAA;EA1BJ;EA4BI;IACE,UAAA;EA1BN;AACF;;AA+BA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AA5BF;;AA+BA;EACE,cAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA5BF;AA8BE;EATF;IAUI,kBAAA;IACA,QAAA;IACA,WAAA;IACA,YAAA;IACA,QAAA;IACA,gCAAA;EA3BF;AACF;AA6BE;EACE,aAAA;AA3BJ;AA6BI;EAHF;IAII,aAAA;EA1BJ;AACF;AA8BI;EACE,yBAAA;EACA,qCAAA;AA5BN;;AAiCA;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AA9BF;AAgCE;EAVF;IAWI,WAAA;IACA,eAAA;IACA,YAAA;EA7BF;AACF;AA+BE;EAhBF;IAiBI,aAAA;EA5BF;AACF;AA8BE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AA5BJ;AA8BI;EAXF;IAYI,WAAA;IACA,YAAA;EA3BJ;AACF;AA6BI;EAhBF;IAiBI,UAAA;IACA,WAAA;EA1BJ;AACF;;AA+BE;EACE,mBAAA;AA5BJ;AA8BI;EACE;IACE,oBAAA;EA5BN;AACF;;AAiCA;EACE,gBAAA;EACA,wBAAA;EACA,yBAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;AA9BF;AA+BE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA7BJ","sourcesContent":[".wrap {\r\n  @media (min-width: 1200px) {\r\n    position: absolute;\r\n    width: 256px;\r\n    z-index: 3;\r\n    background-color: var(--white);\r\n    border: 1px solid var(--gray-100);\r\n    border-radius: 4px;\r\n    padding: 8px;\r\n  }\r\n\r\n  :global {\r\n    .employees {\r\n      &__grid {\r\n        display: block;\r\n      }\r\n    }\r\n\r\n    .searchBlock {\r\n      margin-bottom: 16px;\r\n      margin-top: 0;\r\n\r\n      @media (min-width: 1200px) {\r\n        margin-bottom: 4px;\r\n      }\r\n\r\n      input {\r\n        height: 28px;\r\n        border-radius: 4px;\r\n        padding: 6px;\r\n        background: #F0F1F5;\r\n      }\r\n    }\r\n  }\r\n\r\n  // &--is-top {\r\n  //   // @media (min-width: 1200px) {\r\n  //   //   top: auto;\r\n  //   //   bottom: calc(100% + 6px);\r\n  //   // }\r\n  // }\r\n\r\n  &-is-objects {\r\n    max-width: 630px;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.footer {\r\n  display: flex;\r\n  align-items: center;\r\n  grid-column-gap: 8px;\r\n  padding-top: 8px;\r\n\r\n  @media (min-width: 1200px) {\r\n    grid-column-gap: 4px;\r\n  }\r\n}\r\n\r\n.btnSubmit {\r\n  flex: 1;\r\n}\r\n\r\n.btnReset {\r\n  width: auto;\r\n}\r\n\r\n.grid {\r\n  display: block;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  grid-gap: 12px;\r\n  margin-bottom: 12px;\r\n\r\n  @media (min-width: 768px) {\r\n    display: grid;\r\n  }\r\n\r\n  &--is-skeleton {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.skeleton {\r\n  width: 100%;\r\n  height: 164px;\r\n  border-radius: 12px;\r\n\r\n  margin-bottom: 12px;\r\n\r\n  &:last-child {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  @media (min-width: 768px) {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  &--sm {\r\n    height: 34px;\r\n    margin-bottom: 2px;\r\n  }\r\n\r\n  &--xl {\r\n    height: 56px;\r\n    margin-bottom: 2px;\r\n  }\r\n}\r\n\r\n.label {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  position: relative;\r\n  padding-right: 6px;\r\n\r\n  @media (min-width: 1200px) {\r\n    padding-right: 0;\r\n  }\r\n\r\n  &--hierarhical {\r\n    padding-right: 6px;\r\n    height: 48px;\r\n    align-items: stretch;\r\n    // gap: 8px;\r\n    // border-bottom: 1px solid #E0E7EB;\r\n\r\n    .inputWrap {\r\n      order: -1;\r\n      position: initial;\r\n      width: 16px;\r\n      height: 100%;\r\n      transform: initial;\r\n      margin-right: 8px;\r\n\r\n      svg {\r\n        display: flex;\r\n      }\r\n\r\n      .itemIco {\r\n        display: flex;\r\n        width: 14px;\r\n        height: 14px;\r\n        min-width: 14px;\r\n\r\n        &::before {\r\n          width: 6px;\r\n          height: 6px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  @media (hover: hover) {\r\n    &:hover {\r\n      svg {\r\n        color: var(--white);\r\n      }\r\n    }\r\n  }\r\n\r\n  .item {\r\n    flex: 1;\r\n    padding-right: 24px;\r\n  }\r\n}\r\n\r\n.arrowRight {\r\n  width: 24px;\r\n  height: 48px;\r\n  padding-left: 8px;\r\n  height: inherit;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 0 4px 4px 0;\r\n  flex-shrink: 0;\r\n\r\n  svg {\r\n    fill: var(--text-color);\r\n  }\r\n\r\n  @media (hover: hover) {\r\n    &:hover {\r\n      background-color: var(--accent-color);\r\n      filter: opacity(0.5);\r\n\r\n      svg {\r\n        fill: #fff;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.arrowRightPlug {\r\n  width: 24px;\r\n  height: 40px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.inputWrap {\r\n  flex-shrink: 0;\r\n  color: var(--accent-color);\r\n  width: 22px;\r\n  height: 22px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n  @media (min-width: 1200px) {\r\n    position: absolute;\r\n    right: 0;\r\n    width: auto;\r\n    height: auto;\r\n    top: 50%;\r\n    transform: translate(-50%, -50%);\r\n  }\r\n\r\n  svg {\r\n    display: none;\r\n\r\n    @media (min-width: 1200px) {\r\n      display: flex;\r\n    }\r\n  }\r\n\r\n  input:checked {\r\n    &~.itemIco {\r\n      border-color: transparent;\r\n      background-color: var(--accent-color);\r\n    }\r\n  }\r\n}\r\n\r\n.itemIco {\r\n  display: flex;\r\n  border-radius: 50%;\r\n  width: 14px;\r\n  min-width: 14px;\r\n  height: 14px;\r\n  border: 1px solid #D9D9D9;\r\n  position: relative;\r\n  transition: 0.2s;\r\n\r\n  @media (min-width: 640px) {\r\n    width: 20px;\r\n    min-width: 20px;\r\n    height: 20px;\r\n  }\r\n\r\n  @media (min-width: 1200px) {\r\n    display: none;\r\n  }\r\n\r\n  &::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    width: 6px;\r\n    height: 6px;\r\n    background: #fff;\r\n    border-radius: 50%;\r\n\r\n    @media (min-width: 640px) {\r\n      width: 12px;\r\n      height: 12px;\r\n    }\r\n\r\n    @media (min-width: 1200px) {\r\n      width: 6px;\r\n      height: 6px;\r\n    }\r\n  }\r\n}\r\n\r\n.item {\r\n  &--hierarhical {\r\n    align-items: center;\r\n\r\n    @media (hover: hover) {\r\n      &:hover {\r\n        filter: opacity(0.5);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.backButton {\r\n  background: #EEE;\r\n  color: var(--text-color);\r\n  padding: 6px 12px 6px 4px;\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n  border-radius: 47px;\r\n  font-size: var(--fz-md);\r\n  line-height: var(--lh-lg);\r\n  font-weight: 400;\r\n  margin-top: 4px;\r\n  margin-bottom: 4px;\r\n  word-break: break-all;\r\n  .svgWp {\r\n    width: 16px;\r\n    height: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `SelectReference_wrap__9GOK2`,
	"wrap-is-objects": `SelectReference_wrap-is-objects__TFn8v`,
	"footer": `SelectReference_footer__XVmdW`,
	"btnSubmit": `SelectReference_btnSubmit__ViguV`,
	"btnReset": `SelectReference_btnReset__-rmuy`,
	"grid": `SelectReference_grid__k-syf`,
	"grid--is-skeleton": `SelectReference_grid--is-skeleton__CPA2a`,
	"skeleton": `SelectReference_skeleton__4VK-D`,
	"skeleton--sm": `SelectReference_skeleton--sm__IIQgU`,
	"skeleton--xl": `SelectReference_skeleton--xl__HfjIC`,
	"label": `SelectReference_label__XiT82`,
	"label--hierarhical": `SelectReference_label--hierarhical__Rf+Q-`,
	"inputWrap": `SelectReference_inputWrap__NV6Fi`,
	"itemIco": `SelectReference_itemIco__sfU0+`,
	"item": `SelectReference_item__8lG7J`,
	"arrowRight": `SelectReference_arrowRight__I1WrV`,
	"arrowRightPlug": `SelectReference_arrowRightPlug__H4zxw`,
	"item--hierarhical": `SelectReference_item--hierarhical__GLI7+`,
	"backButton": `SelectReference_backButton__K6dIh`,
	"svgWp": `SelectReference_svgWp__5Itop`
};
export default ___CSS_LOADER_EXPORT___;
